import React from 'react';
import PickupRequestPage from './PickupRequestPage';

const ClientPickupRequest = () => (
  <PickupRequestPage
    requestType="CLIENT"
    title="Client Pickup Request"
    subtitle="Clients can request order pickup — register and track pickup intents here."
  />
);

export default ClientPickupRequest;